module.exports = __webpack_public_path__ + "static/media/bg_404.cd3f84e9.png";